<template>
	<div class="addcustomer_default" ref="addcustomer_default">
		<el-form ref="addcustomerform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
			<el-row style="margin-bottom:15px;margin-top:15px;">
				<el-col :span="8" style="color:transparent">1</el-col>
				<el-col :span="8"><el-input type="text" v-model="keyword" @keyup.native="val => getcompany(val)" placeholder="输入纳税号或者公司名称 回车即可读取公司信息"></el-input></el-col>
			</el-row>
			<el-row style="margin-bottom:15px;">
				<addcurstomerinfo ref="addcurstomerbase" l_mode="客户资料-基本信息"  title="客户信息" :isdetail="isdetail"></addcurstomerinfo>
			</el-row>
			<el-row style="margin-bottom:15px;">
				<addcurstomerinfo ref="addcurstomerinvoice" l_mode="客户资料-开票信息" title="开票信息" :isdetail="isdetail" ></addcurstomerinfo>
			</el-row>
			<el-row style="margin-bottom:45px;">
				<addcurstomerinfo ref="addcurstomerbank" l_mode="客户资料-银行信息" title="银行信息" :isdetail="isdetail"></addcurstomerinfo>
			</el-row>
		</el-form>
		<el-row class="footerhandler" v-if="!btndisabled&&!isdetail">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savecustomer">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="reback">返回</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import addcurstomerinfo from '@/components/crm/addcurstomerinfo.vue';
export default {
	components: {
		addcurstomerinfo
	},
	props: {
	},
	data() {
		return {
			btndisabled:false,
			//type: '默认',
			windowHeight: window.innerHeight - 150,
			model1: [],
			customerinfo: {},
			t_id:'crm_1',
			p_mode:'crm_1',
			divclass:'addcustomer_default',
			iscopy:0,
			isdetail:false,
			id:'',
			keyword:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/crm/addcustomer.scss');
		});
	},
	methods: {
		init(param) {
			this.id='';
			this.iscopy=0;
			this.isdetail=false;
			//debugger
			if(param!=undefined){
				if (param.id != undefined) this.id = param.id;
				if (param.iscopy != undefined) this.iscopy = param.iscopy;
				if (param.isdetail!=undefined) this.isdetail=param.isdetail;
			}
			this.GetCustomerInfo();
		},
		//排版
		GetPageLayout() {
			var that = this;
			//根据配置的导入模板
			this.$apipost.get.GetTransFormat({ p_mode: this.p_mode }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					if (res.set != undefined) {
						that.t_id = res.set.t_id;
						if (res.set.t_type == '客户资料'){
							this.$nextTick(function() {
								that.$refs.addcurstomerbase.init({
									syscol: res.set.t_syscol,
									id: that.id,
									iscopy: that.iscopy,
									t_id: that.t_id,
									customerinfo: that.customerinfo
								});
								
								that.$refs.addcurstomerinvoice.init({
									syscol: res.set.t_syscol,
									id: that.id,
									iscopy: that.iscopy,
									t_id: that.t_id,
									customerinfo: that.customerinfo
								});
								
								that.$refs.addcurstomerbank.init({
									syscol: res.set.t_syscol,
									id: that.id,
									iscopy: that.iscopy,
									t_id: that.t_id,
									customerinfo: that.customerinfo
								});
							});
						}
					}
				}
			});
		},
		GetCustomerInfo(){
			var that=this;
			this.$tool.loading('正在加载',this.divclass);
			if(this.id!=''){
				var paraminfo = {
					id: this.id
				};
				this.$apipost.get.GetCustomerInfo({ paraminfo: paraminfo }).then(res => {
					if (res.state == '1') {
						that.customerinfo = res.customerinfo;
						that.GetPageLayout();
					}
				});
			}else
				this.GetPageLayout();
		},
		//获取客户信息实体
		getCusObj() {
			var that = this;
			var that = this;
			var customerinfo = {};
			var info = '';
			var setlist = this.$refs.addcurstomerbase._data.setlist;
			var error = '';
			if (setlist.length > 0) {
				setlist.forEach(e => {
					if (e.value == undefined) {
						e.value = '';
					}
					if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
						error = '请填写' + that.$refs.addcurstomerbase.title + '-' + e.showname;
						info = '';
					} else {
						if (error == '') {
							if (e.coltype == 'float' && e.isnull == 'False' && e.ishidden == 'False') {
								if (!isNaN(Number(e.value))) {
									error = that.$refs.addcurstomerbase.title + '-' + e.showname + '格式不正确';
									info = '';
								}
							}
						}
					}
					if (error == '') info += '"' + e.colname + '":"' + e.value + '",';
					else return false;
				});
				if (error == '') {
					if (info != '') {
						info = info.replace(/\n/g, '');
						info = '{' + info.substring(0, info.length - 1) + '}';
						customerinfo.baseinfo =JSON.parse(JSON.stringify(JSON.parse(info)));
					}
				}
			}
			if (error != '') {
				this.$tool.message(error, 0);
				customerinfo = '';
			}
			if(customerinfo!=''){
				info='';
				setlist = this.$refs.addcurstomerinvoice._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.addcurstomerinvoice.title + '-' + e.showname;
							info = '';
						} else {
							if (error == '') {
								if (e.coltype == 'float' && e.isnull == 'False' && e.ishidden == 'False') {
									if (!isNaN(Number(e.value))) {
										error = that.$refs.addcurstomerinvoice.title + '-' + e.showname + '格式不正确';
										info = '';
									}
								}
							}
						}
						if (error == '') info += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (error == '') {
						if (info != '') {
							info = info.replace(/\n/g, '');
							info = '{' + info.substring(0, info.length - 1) + '}';
							customerinfo.invoice = JSON.parse(JSON.stringify(JSON.parse(info)));
						}
					}
				}
				if (error != '') {
					this.$tool.message(error, 0);
					customerinfo = '';
				}
			}
			if(customerinfo!=''){
				info='';
				setlist = this.$refs.addcurstomerbank._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.addcurstomerbank.title + '-' + e.showname;
							info = '';
						} else {
							if (error == '') {
								if (e.coltype == 'float' && e.isnull == 'False' && e.ishidden == 'False') {
									if (!isNaN(Number(e.value))) {
										error = that.$refs.addcurstomerbank.title + '-' + e.showname + '格式不正确';
										info = '';
									}
								}
							}
						}
						if (error == '') info += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (error == '') {
						if (info != '') {
							info = info.replace(/\n/g, '');
							info = '{' + info.substring(0, info.length - 1) + '}';
							customerinfo.bank = JSON.parse(JSON.stringify(JSON.parse(info)));
						}
					}
				}
				if (error != '') {
					this.$tool.message(error, 0);
					customerinfo = '';
				}
			}
			return customerinfo;
		},	
		//保存客户信息
		savecustomer(){
			var that=this;
			var customerinfo = this.getCusObj();
			if(customerinfo.baseinfo!=undefined){
				customerinfo.u_userid=localStorage.getItem('userid'),
				customerinfo.u_account=localStorage.getItem('u_account'),
				customerinfo.u_name=localStorage.getItem('u_name'),
				customerinfo.u_company=localStorage.getItem('u_company'),
				customerinfo.editid=this.id;
				customerinfo.p_mode = this.p_mode;
				customerinfo.t_id = this.t_id;
				// return false;
				this.btndisabled=true;
				//debugger
				this.$tool.loading('正在保存',this.divclass);
				this.$apipost.post.SaveInfo({paraminfo:customerinfo}).then(res => {
					that.btndisabled=false;
					this.$tool.loadingclose();
					if (res.state=='1'){
						this.$tool.message('保存成功', 1);
						setTimeout(function(){
							that.reback();
						},1500);
					}else{
						this.$tool.message(res.message, 0);
					}
				});
			}
		},
		//返回
		reback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		getcompany(e){
			var that=this;
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 ){
					if(this.keyword!=''){
						//debugger
						this.$apipost.get.GetCompany({keyword:this.keyword}).then(res => {
							if(res.state=='1'){
								
								var setlist=this.$refs.addcurstomerbase._data.setlist;
								//console.log('setlist',setlist);
								 if (setlist.length > 0) {
								 	setlist.forEach(e => {
										if(e.colname=='ctcompany')
											e.value=res.info.company;
										if(e.colname=='ctaddressall')
											e.value=res.info.regaddress;	
									});
								}
								setlist=[];
								setlist=this.$refs.addcurstomerinvoice._data.setlist;
								//console.log('setlist',setlist);
								 if (setlist.length > 0) {
								 	setlist.forEach(e => {
										if(e.colname=='expressid_gn')
											e.value=res.info.vatnumber;
										if(e.colname=='cgcompany')
											e.value=res.info.company;
										if(e.colname=='expressid')
											e.value=res.info.regno;	
										if(e.colname=='cgaddressall')
											e.value=res.info.regaddress;	
									});
								}
							}else
								this.$tool.message(res.message, 0);
						});
					}
				}
			}
		}
	}
};
</script>

<style></style>
